import { Box } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import Image from 'material-ui-image';

import ButtonDownloadMidia from 'components/ButtonDownloadMidia';
import ImageViewer from 'components/ImageViewer';
import LegendaMensagem from 'components/LegendaMensagem';
import MessageBase, { MessageBaseProps } from 'components/MessageBase';

import MessageErrorFallback from './MessageErrorFallback';

type ImageMessageProps = MessageBaseProps;

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    minWidth: spacing(40),
  },
  image: {
    width: '100%',
    borderRadius: spacing(1),
  },
  background: {
    borderRadius: spacing(1),
    color: palette.common.white,
    backgroundColor: alpha(palette.common.black, 0.76),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
  },
}));

export default function ImageMessage(props: ImageMessageProps) {
  const classes = useStyles();

  try {
    const {
      mensagem: {
        id: mensagemId,
        midiaUrl,
        midiaTitulo,
        midiaUrlPrevia,
        midiaDownloadErro,
        atendimentoId,
        grupoChatId,
        baixando,
      },
    } = props;

    return (
      <MessageBase {...props}>
        <Box className={classes.root}>
          <ImageViewer src={midiaUrl} disabled={midiaDownloadErro || !midiaUrl}>
            <Image
              cover
              loading={false}
              src={midiaUrl || midiaUrlPrevia || ''}
              className={classes.image}
              style={{ backgroundColor: 'inherit' }}
            />
          </ImageViewer>

          {midiaDownloadErro && (
            <Box className={classes.background}>
              <ButtonDownloadMidia
                mensagemId={mensagemId}
                atendimentoId={atendimentoId}
                grupoChatId={grupoChatId}
                baixando={baixando}
              />
            </Box>
          )}
        </Box>

        <LegendaMensagem
          legenda={midiaTitulo}
          isMe={props?.fromMe}
          contatosMencionados={props.mensagem.contatosMencionados}
        />
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
